// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__JX1Cu","subheader":"ReorderModal_subheader__3R-xq","listWrap":"ReorderModal_listWrap__1DHY2"};